import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  propositions: [],
  primaryProposition: {
    propositionId: ''
  },
  loading: false,
  fetchingPropositions: false,
  currentlyEditingProposition: null
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
